import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

const Box = ({ title, children, testid }) => (
  <div className="mx-auto max-w-xl px-4 py-24 text-center" data-testid={testid}>
    <h1 className="font-display text-3xl font-bold text-[#0A0B0E]">{title}</h1>
    <div className="mt-4 text-slate-600">{children}</div>
    <Link to="/ordine" className="mt-8 inline-flex h-12 items-center rounded-full bg-[#0066FF] px-7 font-semibold text-white">Il mio ordine</Link>
  </div>
);

export function PaymentCancel() {
  const [sp] = useSearchParams();
  return <Box title="Pagamento annullato" testid="payment-cancel">Il pagamento dell'ordine {sp.get("ordine")} non è stato completato. Nessun importo è stato addebitato. Il carrello è ancora disponibile.</Box>;
}

export default function PaymentResult() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [st, setSt] = useState(sid ? null : { payment_status: "paid", order_number: sp.get("ordine") });
  const { clear } = useCart();

  useEffect(() => {
    if (!sid) return undefined;
    let n = 0;
    let t;
    const poll = () => {
      api.get(`/payments/status/${sid}`).then((r) => {
        setSt(r.data);
        if (r.data.payment_status === "pending" && n++ < 15) t = setTimeout(poll, 2000);
      }).catch(() => setSt({ payment_status: "error" }));
    };
    poll();
    return () => clearTimeout(t);
  }, [sid]);
  useEffect(() => {
    if (st?.payment_status === "paid") clear();
  }, [st]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!st || st.payment_status === "pending") return <Box title="Verifica del pagamento…" testid="payment-pending">Stiamo verificando il pagamento con Stripe.</Box>;
  if (st.payment_status === "paid") return <Box title="Grazie per il tuo ordine!" testid="payment-success">Il pagamento dell'ordine <b>{st.order_number}</b> è confermato. Riceverai un'email di riepilogo.</Box>;
  return <Box title="Pagamento non confermato" testid="payment-failed">Il pagamento non risulta completato. Se hai bisogno di aiuto contattaci al +39 379 119 2613.</Box>;
}
